import React, { useState, useEffect } from "react";
import Story from "../components/Story";
import StoryWithIntermission from "../components/StoryWithIntermission";
import Grid from "@mui/material/Grid";
import { LoopCircleLoading } from "react-loadingg";
import Hero from "../components/Hero";
const MainStoryList = () => {
  const [stories, setStories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    fetch("https://revived-witch-api.herokuapp.com/api/stories")
      .then((res) => res.json())
      .then(
        (result) => {
          setStories(result.stories);
          setIsLoaded(true);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  if (error) {
    return <>{error.message}</>;
  } else if (!isLoaded) {
    return (
      <div style={{ height: "100vh", weight: "50%" }}>
        <LoopCircleLoading />
      </div>
    );
  } else {
    return (
      <>
        <Hero title="Paralleled Chronospace" />
        <Grid container spacing={2} style={{ marginBottom: 30, marginTop: 30 }}>
          {stories.map((story) =>
            story.hasIntermission === false ? (
              <Story key={story._id} data={story} />
            ) : (
              <StoryWithIntermission key={story._id} data={story} />
            )
          )}
        </Grid>
      </>
    );
  }
};

export default MainStoryList;
